module.exports = __webpack_public_path__ + "static/media/use_esim_jpn2.aa93922d.png";